import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget, GalleryNumberWidget } from '@kunlun/dependencies';
import { removeDecimalZero } from '../../../utils/number';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Gallery,
    multi: false,
    ttype: [ModelFieldType.Float, ModelFieldType.Currency]
  })
)
export class RemoveZeroGalleryNumberWidget extends GalleryNumberWidget {
  @Widget.Reactive()
  protected get currentValue() {
    return removeDecimalZero(super.currentValue);
  }
}
